// Documento: Asignar conversación a humano
// Categoría: General
// Última actualización: 2024-12-28

const document = {
  "id": "asignar-conversacion-humano",
  "title": "Asignar conversación a humano",
  "category": "General",
  "description": "Aprende a transferir conversaciones de tu chatbot a asesores humanos de manera manual o automática. Runamatic ofrece múltiples métodos para garantizar que tus clientes reciban atención personalizada cuando sea necesario.",
  "explanations": [
    {
      "title": "¿Por qué derivar conversaciones a humanos?",
      "content": "La derivación a humanos es una funcionalidad esencial que permite que tus clientes reciban atención personalizada cuando el chatbot no puede resolver completamente su consulta. Esto es especialmente útil para:\n\n• Consultas complejas que requieren análisis detallado\n• Problemas técnicos específicos\n• Ventas de productos o servicios de alto valor\n• Situaciones que requieren empatía y comprensión humana\n• Escalamiento de quejas o reclamos"
    },
    {
      "title": "Métodos de asignación disponibles",
      "content": "Runamatic ofrece flexibilidad en la asignación de conversaciones, permitiendo tanto intervención manual como automatización completa. Esto garantiza que puedas adaptar el proceso a las necesidades específicas de tu negocio y el flujo de trabajo de tu equipo."
    },
    {
      "title": "Asignación automática inteligente",
      "content": "La función de asignación automática distribuye las conversaciones de manera equitativa entre todos los usuarios activos de tu cuenta. Esto asegura que ningún asesor se sobrecargue de trabajo y que los clientes reciban atención oportuna sin importar la hora del día."
    },
    {
      "title": "Indicadores visuales de derivación",
      "content": "Cuando una conversación ha sido derivada a un humano, Runamatic proporciona indicadores visuales claros tanto en la bandeja de entrada como en el perfil del contacto. Esto permite que tu equipo identifique rápidamente qué conversaciones requieren atención humana."
    }
  ],
  "steps": [
    {
      "title": "Método 1: Derivación escribiendo manualmente",
      "content": "La forma más directa de derivar una conversación es escribiendo directamente al cliente desde la bandeja de entrada. Una vez que envías un mensaje manual, la conversación se marca automáticamente como asignada a humano y se detiene la automatización para ese contacto."
    },
    {
      "title": "Método 2: Derivación desde la bandeja de entrada",
      "content": "Desde la bandeja de entrada, puedes derivar conversaciones de dos maneras:\n\n• **Ícono de carita del robot:** Haz clic en el ícono del robot junto al nombre del contacto para cambiar el estado de automatización\n• **Banner naranja:** Utiliza el banner naranja que aparece en conversaciones activas para realizar la derivación\n\nAmbas opciones te permiten transferir la conversación sin necesidad de escribir un mensaje."
    },
    {
      "title": "Método 3: Derivación desde contactos (múltiples)",
      "content": "Para derivar múltiples conversaciones simultáneamente:\n\n- Ve a la sección \"Contactos\"\n- Selecciona uno o varios contactos usando las casillas de verificación\n- Haz clic en las opciones de acciones masivas\n- Selecciona \"Derivar a humano\" o \"Asignar a humano\"\n\nEste método es ideal cuando necesitas transferir múltiples conversaciones al mismo tiempo."
    },
    {
      "title": "Método 4: Transferencia directa desde flujos",
      "content": "Para configurar la transferencia automática dentro de tus flujos:\n\n- En el constructor de flujos, agrega un nuevo bloque de acción\n- Ve a Acciones > Bandeja de entrada > Transferir conversación a humano\n- Configura las condiciones bajo las cuales se activará la transferencia\n- Opcionalmente, agrega un mensaje informando al cliente sobre la transferencia"
    },
    {
      "title": "Método 5: Asignación automática inteligente desde flujos",
      "content": "Para implementar la distribución automática equitativa:\n\n- En tu flujo, agrega una acción\n- Selecciona Acciones > Bandeja de entrada > Asignación automática a humano\n- Esta función distribuirá automáticamente los chats de manera simétrica entre todos los usuarios activos de tu cuenta\n- Configura un mensaje de transición para informar al cliente que será atendido por un asesor"
    },
    {
      "title": "Configurar mensajes de transición",
      "content": "Es recomendable configurar mensajes que informen al cliente sobre la transferencia:\n\n• \"Te estoy conectando con uno de nuestros asesores especializados\"\n• \"Un miembro de nuestro equipo se hará cargo de tu consulta\"\n• \"En un momento un asesor humano continuará atendiéndote\"\n\nEsto mejora la experiencia del cliente y establece expectativas claras."
    },
    {
      "title": "Verificar el estado de derivación",
      "content": "Para confirmar que la derivación fue exitosa:\n\n- Revisa que el ícono del robot haya cambiado de estado en la bandeja de entrada\n- Verifica que aparezca el indicador de \"asignado a humano\" en el perfil del contacto\n- Confirma que se haya detenido la automatización para ese contacto específico"
    }
  ],
  "tags": [
    "derivación",
    "humano",
    "asesor",
    "bandeja-entrada",
    "contactos",
    "flujos",
    "automatización",
    "atención-cliente"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
